import { parseSeoJsonField } from 'components/StructuredData/structuredDataHelpers';
import { ProductJSONLDSchema } from 'components/StructuredData/types';
import { deepMerge } from 'utils/helpers';
import { SeoData } from 'utils/types/contentfulTypes';

import { SeoProps } from './';

export default function parseSeoData(
  seoData: SeoData | Queries.ContentfulSeo001,
  productSchemaBase?: ProductJSONLDSchema,
): SeoProps {
  const faqSchema =
    seoData?.faqSchema?.map((faq) => ({
      question: faq?.question || '',
      answer: faq?.answer || '',
    })) || [];

  const contentfulSchemaOverrides = parseSeoJsonField(seoData?.productSchema);
  // Contentful stores an empty object (`{}`) when a page opts into product
  // schema without overrides, so the field's presence is the signal rather
  // than whether it has keys.
  const hasProductSchema = !!seoData?.productSchema;

  return {
    title: seoData?.metaTitle || '',
    description: seoData?.metaDescription?.metaDescription || '',
    keywords: seoData?.metaKeywords?.join(', ') || '',
    url: seoData?.canonicalUrl || '',
    canonicalUrl: seoData.canonicalUrl || '',
    noIndex: seoData?.metaKeywords?.includes('no-index') || false,
    faqSchema,
    productSchema:
      hasProductSchema && productSchemaBase
        ? deepMerge(productSchemaBase, contentfulSchemaOverrides)
        : undefined,
  };
}
